
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Devices"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceListFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hardware"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HardwareBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hourIssue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceIssueBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"laneSide"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneSideFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lane"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"store"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoreBasicFields"},"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":617}};
    doc.loc.source = {"body":"#import '../device_issue/DeviceIssueBasicFieldsFragment.gql'\n#import '../hardware/HardwareBasicFieldsFragment.gql'\n#import '../lane/LaneBasicFieldsFragment.gql'\n#import '../lane_side/LaneSideFieldsFragment.gql'\n#import '../store/StoreBasicFieldsFragment.gql'\n#import './DeviceListFieldsFragment.gql'\n\nquery Devices {\n  devices {\n    ...DeviceListFields\n\n    hardware {\n      ...HardwareBasicFields\n    }\n\n    hourIssue {\n      ...DeviceIssueBasicFields\n    }\n\n    laneSide {\n      ...LaneSideFields\n\n      lane {\n        ...LaneBasicFields\n\n        store {\n          ...StoreBasicFields\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../device_issue/DeviceIssueBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../hardware/HardwareBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane/LaneBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../lane_side/LaneSideFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../store/StoreBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./DeviceListFieldsFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Devices"] = oneQuery(doc, "Devices");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/device/DevicesQuery.gql
// module id = 95Qq
// module chunks = 87